module.exports = __webpack_public_path__ + "static/media/va-dark.c0df611a.svg";